import * as React from 'react';
import { Button, ButtonProps } from '@/components/ui/button';
import { FileText } from 'lucide-react';
import { ExportProgressModal } from './ExportProgressModal';
import { useExportPolling } from '@/hooks/useExportPolling';

interface ExportButtonProps extends Omit<ButtonProps, 'onClick'> {
  exportType: string;
  filters?: Record<string, unknown>;
  onExportComplete?: () => void;
  children?: React.ReactNode;
}

export function ExportButton({
  exportType,
  filters,
  onExportComplete,
  children,
  ...buttonProps
}: ExportButtonProps) {
  const [modalOpen, setModalOpen] = React.useState(false);

  const {
    exportData,
    isLoading,
    error,
    startExport,
    reset,
  } = useExportPolling({
    onComplete: () => {
      onExportComplete?.();
    },
    onError: (err) => {
      console.error('Export error:', err);
    },
  });

  const handleClick = async () => {
    setModalOpen(true);
    await startExport(exportType, filters);
  };

  return (
    <>
      <Button
        variant="outline"
        onClick={handleClick}
        disabled={isLoading}
        {...buttonProps}
      >
        <FileText className="mr-2 h-4 w-4" />
        {children || 'Exporter'}
      </Button>

      <ExportProgressModal
        open={modalOpen}
        onOpenChange={setModalOpen}
        exportData={exportData}
        isLoading={isLoading}
        error={error}
        onReset={reset}
      />
    </>
  );
}
